import { render, staticRenderFns } from "./Common.vue?vue&type=template&id=12b3a1e0&scoped=true"
import script from "./Common.vue?vue&type=script&lang=js"
export * from "./Common.vue?vue&type=script&lang=js"
import style0 from "./Common.vue?vue&type=style&index=0&id=12b3a1e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b3a1e0",
  null
  
)

export default component.exports